import React from 'react'
import ContentLayout from '../../components/ContentLayout/ContentLayout'
import MainHeading from '../../components/MainHeading/MainHeading'
import PropTypes from 'prop-types'
import NewEquipmentImage from '../../svg/NewEquipment.svg'
import UsedEquipmentImage from '../../svg/UsedEquipment.svg'
import Button from '../../components/Button/Button'
import AppRoutes from '../../routes/appRoutes'

const InfoCard = ({ title, description, iconSrc, onClick, buttonText }) => {
    return (
        <div className="md:w-116 w-full lg:h-86 h-auto flex items-center justify-between flex-col lg:gap-y-6 gap-y-0 lg:p-6 p-4 rounded-3xl border border-grayLines bg-white">
            <img src={iconSrc} className="object-cover lg:mb-0 mb-4" />
            <div className="w-full h-auto flex items-center justify-center flex-col gap-y-2">
                <p className="text-textDarkerGray font-medium text-lg">
                    {title}
                </p>
                <p className="text-textDarkGray font-normal text-base text-center">
                    {description}
                </p>
            </div>
            <Button
                variant="primary"
                className="w-full lg:h-auto h-10 lg:mt-0 mt-4"
                text={buttonText}
                onClick={onClick}
            />
        </div>
    )
}

InfoCard.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    iconSrc: PropTypes.string,
    onClick: PropTypes.func,
    buttonText: PropTypes.string,
}

const EquipmentFinderPage = ({ history }) => {
    return (
        <ContentLayout>
            <MainHeading
                title="Equipment Finder"
                subtitle="What type of equipment are you looking for?"
            />
            <div className="w-full h-auto max-h-full overflow-auto lg:py-12 lg:px-6">
                <div className="w-full h-auto flex lg:flex-row flex-col items-center justify-center lg:p-6 p-4 gap-6">
                    <InfoCard
                        title="Used Equipment"
                        description="We have a large selection of inventory and used-equipment. All of our equipment is maintained and goes through a full preparation process before delivery to the new owner."
                        buttonText="View Assets"
                        iconSrc={UsedEquipmentImage}
                        onClick={() => {
                            history?.push(AppRoutes.usedEquipmentRequest())
                        }}
                    />

                    <InfoCard
                        title="New Equipment"
                        description="Investing in extending the size range of your current fleet of equipment, is a great way to expand your business's reach."
                        buttonText="Submit Equipment Request"
                        iconSrc={NewEquipmentImage}
                        onClick={() => {
                            history?.push(AppRoutes.newEquipmentRequest())
                        }}
                    />
                </div>
            </div>
        </ContentLayout>
    )
}

EquipmentFinderPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }),
}

export default EquipmentFinderPage
